import { dataContextGuard } from './dataContext';
import { fetchJson } from './api';

// The server admits one quality report per tenant/supplier. Keep reads serial
// even when React cancels a screen: aborting fetch does not release the server's
// database slot. Cancelled results are never delivered to the old UI/query.
let tail: Promise<unknown> = Promise.resolve();
export async function qualityRead<T>(url: string, signal?: AbortSignal): Promise<T> {
  const checkContext = dataContextGuard();
  const request = tail.catch(() => undefined).then(async () => {
    checkContext();
    signal?.throwIfAborted();
    return fetchJson<T>(url);
  });
  tail = request.catch(() => undefined);
  const result = await request;
  checkContext();
  signal?.throwIfAborted();
  return result;
}
